import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const QuestionLabel = styled.span`
  ${({ marginBottom }) => marginBottom && 'margin-bottom: 15px;'}
  color: ${({ theme }) => theme.text};
  font-size: 14px;
  user-select: text;
  font-weight: 500;
  padding-bottom: 25px;
  white-space: pre-wrap;
  line-height: 20px;
`; // if you are planning to remove line-height, it will impact on screeners.

export const TextError = styled(TextLayoutComponent.Error)`
  margin-top: 15px;
`;

export const FieldName = styled(TextLayoutComponent.Bold)`
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  word-wrap: break-word;
  margin-top: 15px;
`;

export const OptionContainer = styled.div`
  display: ${(props) => (props.optionType === 'other' ? 'flex' : 'block')};
  flex-direction: ${(props) => (props.optionType === 'other' ? 'row' : 'column')};
  align-items: ${(props) => (props.optionType === 'other' ? 'center' : 'flex-start')};
`;

export const SubText = styled(TextLayoutComponent)`
  padding-bottom: 25px;
`;
